module.exports = __webpack_public_path__ + "img/Info Page 2 right.2a9685a0.png";